<script setup lang="ts">
const props = defineProps({
    code: {
        type: String,
        default: ''
    }
});

const compilationId = ref('');
const name = ref('');
const items = ref<any[]>([]);

onMounted(() => {
    useFetchProxyApi(`/api/media/compilations/${props.code}`, {
        params: {
            select: ['id', 'name', 'items']
        },
        // Изменяем ответ response
        transform: (response: any) => ({
            compilationId: response?.data?.id,
            name: response?.data?.name,
            items: response?.data?.items
        })
    }).then(({ data }: any) => {
        compilationId.value = data.value.id;
        name.value = data.value.name;
        // Url
        items.value = data.value.items.map((data: any) => {
            data.url = useUrl(data.item, data.type, compilationId.value);
            return data;
        });
    });
});
</script>

<template>
    <div v-if="items.length" class="mt-32">
        <h2 class="title fs-30 fs_m-24">{{ name }}</h2>
        <div class="mt-24">
            <CarouselBaseHorizontal :items="items" @selected="(e) => navigateTo(e.data.url)">
                <!-- skeleton preload -->
                <template #skeleton>
                    <div class="media-preview media-preview_blocked">
                        <span class="media-preview__image">
                            <span class="media-preview__image-placeholder"> </span>
                        </span>
                        <span class="media-preview__name title fs-20 mt-16"></span>
                    </div>
                </template>
                <!-- item -->
                <template #default="{ data }">
                    <MediaPreview :type="data?.type" :item="data?.item" />
                </template>
            </CarouselBaseHorizontal>
        </div>
    </div>
</template>
